import { gql } from "@apollo/client/core";

export default gql`
    mutation DeleteInsurer($id: ID!) {
        deleteInsurer(input: { id: $id }) {
            errors
            status
            statusCode
        }
    }
`
